import {apiBase} from './baseAPI.js'

const search = async (agentId) => {
  const params = {
    agentId: agentId,
  }
  const res = await apiBase.post(`/userProfile/search`, params)
  // console.log(res.data)
  return res.data
}

const downloadAppointmentLetter = async (agentId) => {
  const params = {
    agentId: agentId,
  }
  const res = await apiBase.post(`/userProfile/downloadAppointmentLetter`, params)
  console.log(res.data)
  return res.data
}

export const apiUserProfile = {
  search: search,
  downloadAppointmentLetter: downloadAppointmentLetter,
}
